<template>
  <div class="customer-payment body">
    <el-container>
      <!-- <Aside /> -->
      <el-main>
        <SearchCustomers
          :customer="paymentForm.customer"
          @selectedCustomer="selectedCustomer"
          :productsLength="productsLength"
          :productSearch="false"
          :searchOnly="false"
          :showLabel="true"
        />
        <div class="bg-White p-3 mt-2">
          <el-row :gutter="10">
            <el-col :xl="6" :lg="6" :md="12" :sm="12">
              <div class="searchForm">
                <label for="search">المبلغ</label>
                <el-input
                  id="paied"
                  class="mt-2"
                  type="number"
                  @focus="$event.target.select()"
                  v-model="paymentForm.paied"
                  controls-position="right"
                  @keyup.enter.native="setNotesFocus"
                ></el-input>
              </div>
            </el-col>
            <el-col :xl="14" :lg="14" :md="12" :sm="12">
              <div class="searchForm">
                <label for="search">ملاحظات</label>
                <el-input
                  class="mt-2"
                  type="text"
                  id="notes"
                  @focus="$event.target.select()"
                  v-model="paymentForm.notes"
                  controls-position="right"
                  @keyup.enter.native="pay"
                ></el-input>
              </div>
            </el-col>
            <el-col :xl="4" :lg="4" :md="12" :sm="12">
              <br />
              <el-button class="mt-2" type="warning" @click="pay()">
                تحصيل</el-button
              >
            </el-col>
          </el-row>
        </div>
      </el-main>
    </el-container>
  </div>
</template>
<script>
import SearchCustomers from "@/components/Customers/Search";
import Aside from "@/components/aside.vue";
import axiosApi from "@/plugins/axios.js";

export default {
  name: "CustomerPayment",
  components: { SearchCustomers, Aside },
  data() {
    return {
      false: false,
      true: true,
      productsLength: 0,
      paymentForm: {
        customer: null,
        inventory_id: 1,
        paied: "",
        notes: "",
      },
    };
  },
  methods: {
    selectedCustomer(e) {
      this.paymentForm.customer = e.customer;
      setTimeout(() => {
        document.getElementById("paied").focus();
      }, 100);
    },
    setNotesFocus() {
      setTimeout(() => {
        if (this.paymentForm.paied > 0) {
          document.getElementById("notes").focus();
        }
      }, 100);
    },
    pay() {
      const customer = this.paymentForm.customer;
      axiosApi
        .post("customers/pay", this.paymentForm)
        .then(() => {
          this.paymentForm.paied = "";
          this.paymentForm.notes = "";
          this.paymentForm.customer = null;
          setTimeout(() => {
            this.paymentForm.customer = customer;
          }, 100);
          this.$notify({
            title: "تمت العملية بنجاح",
            message: "تم حفظ عملية التحصيل بنجاح",
            type: "success",
            duration: 1500,
          });
        })
        .catch(() => {
          this.$notify({
            title: "حدث خطأ",
            message: "عفوا لم تتم العملية ",
            type: "error",
            duration: 1500,
          });
        });
    },
  },
};
</script>